//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SfButton from "../../atoms/SfButton/SfButton.vue";
import SfHeading from "../../atoms/SfHeading/SfHeading.vue";

export default {
  name: "SfArticleCard",
  components: {
    SfButton,
    SfHeading,
  },
  props: {
    image: {
      type: Object
    },
    title: {
      type: String,
      default: "",
    },
    titleLevel: {
      type: [Number, String],
      default: 5,
    },
    description: {
      type: String,
      default: "",
    },
    link: {
      type: String,
      default: "",
    },
    buttonText: {
      type: String,
      default: "",
    },
    secondaryLink: {
      type: String,
      default: "",
    },
    secondaryButtonText: {
      type: String,
      default: "",
    },
    themeColor: {
      type: String,
      default: "var(--c-secondary-turquoise)",
    }
  },
};
